
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.409 3.23l1.035 2.042 2.265.336c.168.037.29.14.364.307a.49.49 0 01-.112.448l-1.65 1.622.391 2.238a.468.468 0 01-.195.447.432.432 0 01-.448.028L9.017 9.635l-2.014 1.063a.48.48 0 01-.475-.028.468.468 0 01-.196-.447l.392-2.238L5.1 6.363a.409.409 0 01-.111-.448.434.434 0 01.335-.307l2.266-.336L8.626 3.23a.396.396 0 01.391-.251c.187 0 .317.084.392.251zM8.29 5.888a.514.514 0 01-.336.251l-1.594.224L7.535 7.51c.093.093.13.224.112.391l-.28 1.595 1.454-.756a.37.37 0 01.392 0l1.455.756-.28-1.595c-.019-.167.018-.298.112-.391l1.174-1.147-1.594-.224a.514.514 0 01-.336-.252l-.727-1.454-.727 1.455z","fill":"#000"}}),_c('path',{attrs:{"d":"M11 15H2a.974.974 0 01-.719-.281A.974.974 0 011 14V3.278a2.021 2.021 0 00-.406.316C.219 3.969.02 4.438 0 5v9c.02.563.219 1.031.594 1.406S1.438 15.98 2 16h9c.563-.02 1.031-.219 1.406-.594.126-.126.232-.262.318-.41H11.09A1.26 1.26 0 0111 15z","fill":"#000"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.999 14H4c-.563-.02-1.031-.219-1.406-.594S2.02 12.562 2 12V2c.02-.563.219-1.031.594-1.406S3.438.02 4 0h10c.563.02 1.031.219 1.406.594S15.98 1.438 16 2v10c-.02.563-.219 1.031-.594 1.406S14.562 13.98 14 14h-.066v-.003H7.999V14zM14 13H4a.974.974 0 01-.719-.281A.974.974 0 013 12V2c0-.292.094-.531.281-.719A.973.973 0 014 1h10c.292 0 .531.094.719.281A.974.974 0 0115 2v10a.974.974 0 01-.281.719A.974.974 0 0114 13z","fill":"#000"}})])
          )
        }
      }
    